// extracted by mini-css-extract-plugin
module.exports = {"pintxo-field-container":"Field_pintxo-field-container__1HbMr","pintxo-field-container__footer":"Field_pintxo-field-container__footer__B5F9A"};